<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
        <circle id="Ellipse_155" data-name="Ellipse 155" cx="5" cy="5" r="5" fill="#254150"/>
    </svg>
</template>

<script>
export default {
    name: "last-step"
}
</script>

<style scoped>

</style>
